import styled from 'styled-components';

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  padding: 30px;
  background: ${({ theme }) => theme.colors.background_white};
  font-family: 'Poppins', sans-serif;
  border-radius: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  position: relative;
  overflow: visible;
  gap: 24px;

  &::after {
    content: '';
    position: absolute;
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  .button-text {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  @media (max-width: 1024px) {
    padding: 2rem 0;
  }
`;

export const Header = styled.h1`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 40px;
  padding: 15px 20px;
  font-size: 26px;
  color: ${({ theme }) => theme.colors.primary};
  justify-content: space-between;

  h1 {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  @media (max-width: 1250px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  flex-wrap: wrap;
  padding: 10px;

  @media (max-width: 1250px) {
    display: flex;
    font-size: 80px;
    width: 100%;
    align-items: center;
  }

  @media (max-width: 768px) {
    display: flex;
    font-size: 40px;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  @media (max-width: 480px) {
    font-size: 32px;
    width: 70%;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

export const StatisticsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  gap: 20px;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

export const MainStats = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  /* align-items: center; */
  text-align: center;
  justify-content: center;
  align-items: stretch;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 70%;
  }
`;

export const StatBox = styled.div`
  width: 100%;
  flex: 1;
  min-width: 220px;

  background: ${({ theme }) => theme.colors.background_white};
  padding: 24px;
  text-align: center;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  border: 3px solid ${({ theme }) => theme.colors.secondary};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  span:first-child {
    //Texto
    font-size: 20px;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
    margin-bottom: 0px;
  }

  span:last-child {
    //número
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 65px;
    font-weight: bold;
    font-family: 'Poppins', sans-serif;
  }
`;

export const SideStats = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
  align-items: center;
  text-align: center;

  @media (max-width: 1024px) {
    width: 80%;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const SideStatBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.background_white};
  border-radius: 20px;
  padding: 0 20px 20px;
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  span.date {
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.background_white};
    width: 100%;
    padding: 20px;
    font-size: 24px;
    font-weight: bold;
    text-transform: uppercase;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    margin-bottom: 10px;
  }

  span:nth-child(2) {
    font-size: 40px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.background_white};
  }

  span:nth-child(3) {
    font-size: 25px;
    font-weight: bold;
  }

  &.inactive {
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.background_white};

    span.date {
      background: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.background_white};
    }

    span:nth-child(2) {
      color: ${({ theme }) => theme.colors.background_white};
    }
  }
`;
